export function showElement(el, forceHide) {
  if (el.style.display === 'none') { el.style.display = ''; }
}


//////////////////
// WEBPACK FOOTER
// ./~/tiny-slider/src/helpers/showElement.js
// module id = 867
// module chunks = 2